import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import core from '@bravissimolabs/website-core';

import Meta from 'shared/containers/MetaContainer';
import Grid from 'brastrap/containers/grid/GridContainer';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import ProductReviews from '../../Product/containers/ProductReviewsContainer';
import schemaGenerator from '../reviewSchemaGenerator';
import { setSchema } from '../../../actions/schema';

import { getWrapperContainers } from '../../../actions/editorial';

export const SETTING_GROUP = 'reviews';

const messages = defineMessages({
  title: {
    id: 'reviews-all.title',
    defaultMessage: 'All Customer Reviews & Ratings | Lingerie & Swimwear Shop',
  },
});

const ReviewsPage = (props: Props) => {
  const {
    intl: { formatMessage },
    getContainers,
    headerContainers,
    footerContainers,
  } = props;
  useEffect(() => {
    getContainers();
  }, []);

  const reviewSchema = schemaGenerator(props);
  props.schemas.push(reviewSchema);

  return (
    <Meta title={formatMessage(messages.title)} schemas={props.schemas}>
      <div className="c-page__main">
        <Grid>
          <Grid.Content>
            {headerContainers && !!headerContainers.length && (
              <EditorialContainer containers={headerContainers} />
            )}
            <ProductReviews isAllReviews />
            {footerContainers && !!footerContainers.length && (
              <EditorialContainer containers={footerContainers} />
            )}
          </Grid.Content>
        </Grid>
      </div>
    </Meta>
  );
};

ReviewsPage.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
  getContainers: PropTypes.func.isRequired,
  headerContainers: PropTypes.array,
  footerContainers: PropTypes.array,
};

const mapStateToProps = state => {
  const schemas = [];

  if (state.schema.organisation) {
    schemas.push(state.schema.organisation);
  }

  if (state.schema.siteSearch) {
    schemas.push(state.schema.siteSearch);
  }
  return {
    baseUrl: state.app.serverAndPort,
    schemas,
    headerContainers: state.content.headerContainers || [],
    footerContainers: state.content.footerContainers || [],
    productReviews: state.productReviews.reviews || [],
  };
};

const mapDispatchToProps = dispatch => ({
  getContainers: () => dispatch(getWrapperContainers(SETTING_GROUP)),
});

ReviewsPage.populateStore = async (store, props, req) => {
  const url = `${req.protocol}://${req.headers.host}${
    store.getState().app.routing.url
  }`;

  const organisationSchema = await core.content.schema.get('organisation', {
    url,
  });

  const siteSearchSchema = await core.content.schema.get('siteSearch', { url });

  if (organisationSchema) {
    store.dispatch(setSchema('organisation', organisationSchema));
  }

  if (siteSearchSchema) {
    store.dispatch(setSchema('siteSearch', siteSearchSchema));
  }

  store.dispatch(getWrapperContainers(SETTING_GROUP));
};

const WrappedReviewsPage = injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ReviewsPage)
);

export default WrappedReviewsPage;
